import React from 'react';
import style from './BlogSections.module.css';
import { useLocation } from 'react-router';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Loading from '../../components/Loading/Loading.jsx';
import NoData from '../../components/NoData/NoData.jsx';
import '../../components/headersStyling.css';
import { getBlogSections } from '../../Api/blogApis';
import noImage from '../../assets/images/noImage.png';
import { filterLanguage } from './../../utilities/filterFunction';
import { basename } from './../../configiration/config';
import { imgResize } from './../../utilities/imageResize';

function Blog() {
    const { pathname } = useLocation();
    const [t] = useTranslation();

    const [blogSections, setBolgSections] = useState([]);
    const [blogSectionsImage, setBolgSectionsImage] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
      window.scrollTo(0, 0);
    }, [pathname]);

    useEffect(() => {
        getBlogSections().then(response => {
            if(response.data.status === true){
                if(response.data.data && response.data.data.image){
                    setBolgSectionsImage(response.data.data.image)
                }
                if(response.data.data && response.data.data.blog_sections){
                    setBolgSections(response.data.data.blog_sections)
                }
            }
            setLoading(false);
        })
        .catch(error => {
            setLoading(false);
        });
        // eslint-disable-next-line
    }, []);

    return (
        <div>
            {/* START OF HEADER SECTION */}
            <div className={`myHeader d-flex align-items-center justify-content-center`} style={{ backgroundImage: `url(${imgResize(blogSectionsImage,1920,0)})` }}>
                <div className={`myHeaderContent`}>
                    <h1>{t('blog')}</h1>
                    <p>
                        <Link className='homeWord' 
                            to={`${basename}/`}>
                            {t('home')}
                        </Link>
                        / {t('blog')}
                    </p>
                </div>
            </div>
            {/* START OF HEADER SECTION */}


            {/* START OF BLOG CATEGORIES SECTION */}
            <div className={`${style.myCustomContainer}`}>
                <div className={`${style.blogCategories} row`}>
                    { !loading && blogSections && blogSections.map(blogSection => {
                        let selectedBlog= filterLanguage(blogSection.locales)
                        return(
                        <Link key={blogSection.slug} to={`${basename}/blogs/${blogSection.slug}`} state={{section: blogSection}} className={`${style.categoryContainer} col-md-6 px-0`}>
                            <div className={`${style.category} card `}>
                                <div className={`${style.categoryImg}`}>
                                    <img src={imgResize(blogSection.image,703,0)} className="w-100" alt="categoryImg" onError={(e)=>{e.target.src=noImage}}/>
                                </div>
                                <div className={`${style.cardBody} card-body p-0`}>
                                    <h5 className={`${style.categoryTitle} card-title`}>{selectedBlog.length && selectedBlog[0].name }</h5>
                                    <p className={`${style.categoryDesc} card-text`}>{selectedBlog.length && selectedBlog[0].description }</p>
                                </div>
                            </div>
                        </Link>
                    )}
                    )}

                    { loading && (
                        <Loading width='100px' height='100px' />
                    )}

                    { !loading && (!blogSections || !blogSections.length) &&
                        <NoData text='No available data' />
                    }
                </div>
            </div>
            {/* END OF BLOG CATEGORIES SECTION */}

        </div>
    )
}

export default Blog